export default {"src":"/_next/static/media/CheckBoxActive.1468b754.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};